import acc from '../../assets/accounting.jpeg'
import React, { useState } from 'react';
import { StudentNavbar, ModuleOverview, SubjectOverview, SubjectSideNavigation } from '../../components';

const Accounting= () => {
  
  const subjectName = "Accounting";
  const [selectedUnit, setSelectedUnit] = useState({ index: 0, title: { subjectName } });
  const accountingConcepts = [
    'Lorem Ipsum. Lorem Ipsum. Lorem Ipsum. Lorem Ipsum. Lorem Ipsum.',
    'Lorem Ipsum. Lorem Ipsum. Lorem Ipsum. Lorem Ipsum. Lorem Ipsum. Lorem Ipsum. ',
    'Lorem Ipsum. Lorem Ipsum. Lorem Ipsum. Lorem Ipsum. Lorem Ipsum. Lorem Ipsum. ',
    'Lorem Ipsum. Lorem Ipsum. Lorem Ipsum. Lorem Ipsum. Lorem Ipsum. Lorem Ipsum. ',
  ];

  return (
    <div>
      <StudentNavbar />
      <div className="bg-white w-full">
        <div className="grid grid-cols-5">
          <div className="col-span-1 text-sm">
            <SubjectSideNavigation setSelectedUnit={setSelectedUnit} subjectName={subjectName} img = {acc} />
          </div>

          <div className="col-span-4 bg-[#f0f0f0] min-h-screen h-full px-5 py-5 h-[calc(100vh-100px)] overflow-y-auto">
            {selectedUnit.index !== 0 ? (
              <ModuleOverview
                unit_num={selectedUnit.index}
                unit_title={selectedUnit.title}
                subjectName={subjectName}
                img = {acc}
              />
            ) : (
              <SubjectOverview
                subjectName={subjectName}
                examType="BGCSE"
                keyConcepts={accountingConcepts}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accounting